// src/components/Payment/addbanner.js
import React from 'react';

const Hotelbooking = () => {
  return (
    <div>
      <h2>Hotelbooking</h2>
      <p>This is the addbanner component.</p>
    </div>
  );
};

export default Hotelbooking;
